var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.877 93.865 60 71.01l-6.877 22.855-5.745-1.73 9.75-32.4h5.745l9.75 32.4-5.746 1.73Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.858 96H15.142l41.16-57.167-13.737-19.08 4.87-3.506L60 33.7l12.565-17.453 4.87 3.506-13.738 19.08L104.858 96Zm-78-6h66.287L60.003 43.968 26.86 90h-.002Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.689 79.655-5.367 2.683 6.002 12 5.366-2.683-6.001-12ZM102.321 79.666l-6.001 12 5.366 2.684 6.001-12-5.366-2.684Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.326dadc5.svg";
export { ForwardRef as ReactComponent };